const VALUES = [
    {display:'Secured', value:'SEC'},
    {display:'Senior Unsecured', value:'SNUN'},
    {display:'Senior Subordinated', value:'SNSU'},
    {display:'Subordinated', value:'SU'},
    {display:'Junior Subordinated', value:'JUSU'},
    {display:'Preferred Shares', value:'PFD'},
    {display:'Other', value:'OTHR'}
]

export const CORP_DEBT_RANKS = VALUES
    .map(({value, display}) => {
        return {
            label: display,
            display,
            value: 'holdDrnk=' + value
        }
    })

export const CORP_DEBT_RANK_LABELS = Object.fromEntries(VALUES.map(a=> [a.value,a.display]))